import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {EditUrlCardComponent} from '../../alerts/cards/edit-url-card/edit-url-card.component';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {EditFooterLogoComponent} from '../../alerts/footer/edit-footer-logo/edit-footer-logo.component';
import {EditFooterSectionComponent} from '../../alerts/footer/edit-footer-section/edit-footer-section.component';
import {EditFooterTextComponent} from '../../alerts/footer/edit-footer-text/edit-footer-text.component';
import {EditFooterContactComponent} from '../../alerts/footer/edit-footer-contact/edit-footer-contact.component';
import Swal from 'sweetalert2';
import {FooterService} from '../../../services/footer.service';

@Component({
  selector: 'app-footer-grid',
  templateUrl: './footer-grid.component.html',
  styleUrls: ['./footer-grid.component.scss']
})
export class FooterGridComponent implements OnInit {
  @Input() footerData: any;
  @Input() mantenienceSection;
  @Output() callUpdate: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    private serviceModal: NgbModal,
    private footerService: FooterService,
  ) {
  }

  ngOnInit(): void {
  }

  editLogo(logo): any {
    const modal = this.serviceModal.open(EditFooterLogoComponent, {
      centered: true,
      windowClass: 'short-modal d-flex flex-column w-100 justify-content-center'
    });
    modal.componentInstance.footerLogoData = logo;
    modal.result.then((res) => {
      Swal.fire({
        title: 'Insertando información...',
        text: 'Por favor espere',
        icon: 'warning',
        backdrop: false,
      });
      Swal.showLoading();
      this.footerService.editFooterLogo(res)
        .subscribe(response => {
          if (response.valid) {
            this.callUpdate.emit(true);
          }
        });
      }, (reason) => {

      });
  }

  editSection(info, num: number): any {
    const {name} = info;
    const {id} = info;
    const footerItem = info.detail.map(x => {
      return {
        id: x.id,
        item: x.name,
        url: x.url,
        orderId: x.orderId
      };
    });
    const dataToSend = {
      name,
      id,
      footerItem
    };
    const sectionInfo = {...info};
    const modal = this.serviceModal.open(EditFooterSectionComponent, {
      centered: true,
      windowClass: 'custom-modal-benefit d-flex flex-column w-100 justify-content-center h-95pr'
    });
    modal.componentInstance.footerSectionInfo = dataToSend;
    modal.result.then((res) => {
      Swal.fire({
        title: 'Insertando información...',
        text: 'Por favor espere',
        icon: 'warning',
        backdrop: false,
      });
      Swal.showLoading();
      if (num === 1) {
        this.footerService.editSectionOne(res)
          .subscribe(response => {
            if (response.valid) {
              this.callUpdate.emit(true);
            }
          });
      } else {
        this.footerService.editSectionTwo(res)
          .subscribe(response => {
            if (response.valid) {
              this.callUpdate.emit(true);
            }
          });
      }
    }, (reason) => {

    });
  }

  editText(textInfo): any {
    const modal = this.serviceModal.open(EditFooterTextComponent, {
      centered: true,
      windowClass: 'short-modal d-flex flex-column w-100 justify-content-center'
    });
    modal.componentInstance.footerTextInfo = textInfo;
    modal.result.then((res) => {
      Swal.fire({
        title: 'Insertando información...',
        text: 'Por favor espere',
        icon: 'warning',
        backdrop: false,
      });
      Swal.showLoading();
      this.footerService.editInformation(res)
        .subscribe(response => {
          if (response.valid) {
            this.callUpdate.emit(true);
          }
        });
      }, (reason) => {

      });
  }

  editContact(contactInfo): any {
    const modal = this.serviceModal.open(EditFooterContactComponent, {
      centered: true,
      windowClass: 'middle-modal d-flex flex-column w-100 justify-content-center'
    });
    modal.componentInstance.footerContactInfo = contactInfo;
    modal.result.then((res) => {
      // do some cool stuff here...
      Swal.fire({
        title: 'Insertando información...',
        text: 'Por favor espere',
        icon: 'warning',
        backdrop: false,
      });
      Swal.showLoading();
      this.footerService.editContactInformation(res)
        .subscribe(response => {
          if (response.valid) {
            this.callUpdate.emit(true);
          }
        });
      }, (reason) => {

      });
  }

  editSocialMedia(socialMediaInfo): any {
    const dataToSend = {
      ...socialMediaInfo,
      isSocialMedia: true
    };
    const modal = this.serviceModal.open(EditFooterContactComponent, {
      centered: true,
      windowClass: 'middle-modal d-flex flex-column w-100 justify-content-center'
    });
    modal.componentInstance.footerContactInfo = dataToSend;
    modal.result.then((res) => {
      // do some cool stuff here...
      Swal.fire({
        title: 'Insertando información...',
        text: 'Por favor espere',
        icon: 'warning',
        backdrop: false,
      });
      Swal.showLoading();
      this.footerService.editContactInformation(res)
        .subscribe(response => {
          if (response.valid) {
            this.callUpdate.emit(true);
          }
        });
      }, (reason) => {

      });
  }

}
